module.exports = __webpack_public_path__ + "img/play-circle.31508a85.svg";